var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"loading":_vm.loadingProjects,"label":"Select a Project","items":_vm.projectList,"item-text":"name","single-line":"","item-value":"pid"},on:{"change":_vm.projectSelected},model:{value:(_vm.selectedProject),callback:function ($$v) {_vm.selectedProject=$$v},expression:"selectedProject"}})
}
var staticRenderFns = []

export { render, staticRenderFns }